import { z } from 'zod'

export const LEARNING_RECONCILIATION_WRITE_CONTRACT_VERSION = '1.0.0' as const
export const LEARNING_RECONCILIATION_SCHEMA_VERSION = 'learning-reconciliation-v1' as const

const schemaVersion = z.object({ schemaVersion: z.literal(LEARNING_RECONCILIATION_SCHEMA_VERSION) })
const requiredReason = z.string().trim().min(1).max(1000)
const requiredActor = z.string().trim().min(1).max(200)
const nullableText = z.string().trim().min(1).max(240).nullable().optional()
const item = z.record(z.unknown())
const itemResponse = z.object({ contract_version: z.literal(LEARNING_RECONCILIATION_WRITE_CONTRACT_VERSION), item }).passthrough()

export const learningReconciliationAcknowledgeRequestSchema = schemaVersion.extend({ reason: requiredReason }).strict()
export const learningReconciliationResolveRequestSchema = schemaVersion.extend({
  resolution: z.string().trim().min(1).max(120),
  reason: requiredReason,
  linkedMappingId: nullableText,
}).strict()
export const learningReconciliationQuarantineRequestSchema = schemaVersion.extend({ reason: requiredReason }).strict()
export const learningExceptionAssignRequestSchema = schemaVersion.extend({ assignedTo: requiredActor, reason: requiredReason }).strict()

export const learningReconciliationAcknowledgeResponseSchema = itemResponse
export const learningReconciliationResolveResponseSchema = itemResponse
export const learningReconciliationQuarantineResponseSchema = itemResponse
export const learningExceptionAssignResponseSchema = z.object({
  contract_version: z.literal(LEARNING_RECONCILIATION_WRITE_CONTRACT_VERSION),
  exceptionId: z.string().min(1),
  type: z.literal('reconciliation'),
  assignedTo: z.string().min(1).nullable(),
  changed: z.boolean(),
  auditId: z.string().min(1).nullable(),
  item,
}).passthrough()

export type LearningReconciliationAcknowledgeRequest = z.infer<typeof learningReconciliationAcknowledgeRequestSchema>
export type LearningReconciliationResolveRequest = z.infer<typeof learningReconciliationResolveRequestSchema>
export type LearningReconciliationQuarantineRequest = z.infer<typeof learningReconciliationQuarantineRequestSchema>
export type LearningExceptionAssignRequest = z.infer<typeof learningExceptionAssignRequestSchema>
export type LearningReconciliationAcknowledgeResponse = z.infer<typeof learningReconciliationAcknowledgeResponseSchema>
export type LearningReconciliationResolveResponse = z.infer<typeof learningReconciliationResolveResponseSchema>
export type LearningReconciliationQuarantineResponse = z.infer<typeof learningReconciliationQuarantineResponseSchema>
export type LearningExceptionAssignResponse = z.infer<typeof learningExceptionAssignResponseSchema>
